<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="reservedInstanceList"
      style="width: 100.1%;"
      :max-height="tableHeight"
      :loading="modalLoading"
    >
      <template slot-scope="{ row, index }" slot="operation">
        <Button
          type="info"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:reservedInstanceResource:elasticsearch:config'
          ]"
          size="small"
          @click="configTag(row)"
          >配置标签</Button
        >
      </template>
    </Table>
    <!-- 配置标签页面 -->
    <configuration-reserved-instance-tag
      v-if="isShowReservedInstanceTag"
      ref="configurationReservedInstanceTag"
    ></configuration-reserved-instance-tag>
  </div>
</template>
<script>
import utils from "../../../../../../utils/utils.js";
import ConfigurationReservedInstanceTag from "../ConfigurationReservedInstanceTag";

var tableElasticsearchResourceVue = {};
export default {
  name: "TableElasticsearchResource",
  components: {
    ConfigurationReservedInstanceTag
  },
  data() {
    return {
      tableHeight: 0,
      isShowReservedInstanceTag: false,
      modalLoading: false,
      columns: [
        {
          title: this.$t("RAM.AWS.RI.ElasticSearch.accountID"),
          key: "awsId",
          fixed: "left",
          minWidth: 120
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticSearch.accountName"),
          key: "awsName",
          minWidth: 150
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticSearch.region"),
          key: "region",
          minWidth: 150
        },
        {
          title: "tag",
          key: "tag",
          minWidth: 150
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticSearch.name"),
          key: "name",
          minWidth: 150
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticSearch.id"),
          key: "id",
          minWidth: 150
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticSearch.CacheNodeType"),
          key: "instanceType",
          minWidth: 150
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticSearch.status"),
          key: "state",
          minWidth: 150
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticSearch.start"),
          key: "start",
          minWidth: 150,
          sortable: true
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticSearch.overdue"),
          key: "end",
          minWidth: 150,
          sortable: true
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticSearch.nodeNumber"),
          key: "instanceCount",
          minWidth: 150
        },
        {
          title: this.$t("RAM.AWS.RI.ElasticSearch.due"),
          key: "duration",
          minWidth: 150
        },
        {
          title: this.$t("common.operation"),
          slot: "operation",
          fixed: "right",
          minWidth: 150
        }
      ],
      reservedInstanceList: [],
      reservedInstanceListData: []
    };
  },
  beforeCreate: function() {
    tableElasticsearchResourceVue = this;
  },
  mounted() {
    window.addEventListener("resize", this.getTableHeight);
    this.getTableHeight();
  },
  methods: {
    getTableHeight() {
      this.tableHeight = window.innerHeight - 210;
    },
    // 显示数据
    getReservedInstances: function(reservedInstanceDTO) {
      tableElasticsearchResourceVue.reservedInstanceDTO = reservedInstanceDTO;
      // 转圈圈
      tableElasticsearchResourceVue.modalLoading = true;
      // 清空数据
      tableElasticsearchResourceVue.reservedInstanceList = [];
      tableElasticsearchResourceVue.$api.reservedInstance
        .getReservedElasticsearchInstances(reservedInstanceDTO)
        .then(res => {
          tableElasticsearchResourceVue.modalLoading = false;
          if (res == null || res.data == null) {
            return;
          }
          let reservedInstances = res.data;
          for (let i = 0; i < reservedInstances.length; i++) {
            reservedInstances[i].start = utils.methods.formatDate(
              reservedInstances[i].start
            );
            reservedInstances[i].end = utils.methods.formatDate(
              reservedInstances[i].end
            );
            reservedInstances[i].duration =
              reservedInstances[i].duration === 31536000 ? "一年" : "三年";
          }
          tableElasticsearchResourceVue.reservedInstanceListData = JSON.parse(
            JSON.stringify(reservedInstances)
          );
          tableElasticsearchResourceVue.reservedInstanceList = reservedInstances;
        });
    },
    configTag: function(row) {
      this.isShowReservedInstanceTag = true;
      this.$nextTick(function() {
        this.$refs.configurationReservedInstanceTag.getConfigurationReservedInstanceTagList(
          row,
          4
        );
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/reserved_instance/elasticsearch/TableElasticsearchResource.vue